import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import store from './store'  // 引入 store
import i18n from './lang'
import VueAMap from 'vue-amap'

// 引入CloudBase初始化实例
import cloudbase from './utils/cloudbase'

// 全局挂载：所有组件可通过this.$tcb访问tcb实例，this.$db访问数据库
Vue.prototype.$tcb = cloudbase.app
Vue.prototype.$db = cloudbase.db


// 2. 将axios挂载到Vue原型上，命名为$axios（$前缀是Vue生态的约定，区分自定义属性和原生属性）
Vue.prototype.$axios = axios

// 可选：配置axios全局默认值（比如基础域名、超时时间等）
axios.defaults.baseURL = 'https://www.3pg.cn' // 接口基础域名
axios.defaults.timeout = 10000 // 请求超时时间（10秒）


Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '4bdaf3519e5b654096db1455959d13bc', // 需替换为自己申请的Key
  plugin: ['AMap.Marker', 'AMap.InfoWindow'],
  v: '1.4.4'
})
// 引入全局 CSS 文件（注意路径要正确）
import './styles/global.css'  // 引入全局样式
import './styles/iconfont.css'  // 引入ICON图标库


import ECharts from 'vue-echarts' // 引入 vue-echarts 组件
import echarts from 'echarts' // 引入 ECharts 实例

// 关键：将 ECharts 实例绑定到组件
Vue.component('v-chart', {
  extends: ECharts,
  props: {
    echarts: {
      default: () => echarts
    }
  }
})

// 按需引入 ECharts 模块（地图需要这些）
import 'echarts/lib/chart/map' // 地图图表模块
import 'echarts/lib/component/tooltip' // 提示框组件（可选）
import 'echarts/map/js/china.js' // 中国地图数据

import BaiduMap from 'vue-baidu-map'

// 全局注册所有百度地图组件，同时传入 AK（无需手动引入单个组件）
Vue.use(BaiduMap, {
  ak: 'jmSe6E9NCsWOOMe1bW4dakistlPyW1nc' // 必须替换为你申请的真实AK
})


import BackToTop from './components/BackToTop.vue'
import FloatingActions from './components/FloatingActions.vue'
import MenuBar from './components/MenuBarPage.vue'
import FooterBar from './components/FooterBar.vue'
import FullscreenPoster from './components/FullscreenPoster.vue'
import RealPageLoading from './components/RealPageLoading.vue';

// 全局注册返回顶部组件
Vue.component('RealPageLoading', RealPageLoading);
Vue.component('BackToTop', BackToTop)
Vue.component('FloatingActions', FloatingActions)
Vue.component('MenuBar', MenuBar)
Vue.component('FooterBar', FooterBar)
Vue.component('FullscreenPoster', FullscreenPoster)

// 2. 创建进度条实例并挂载到Vue原型（全局可调用）
const loadingInstance = new Vue(RealPageLoading).$mount();
// 将进度条DOM插入到页面body最前面
document.body.insertBefore(loadingInstance.$el, document.body.firstChild);
// 挂载到Vue原型，全局通过 this.$pageLoading 调用
Vue.prototype.$pageLoading = loadingInstance;


import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'


// 初始化 html 元素的滚动条
document.addEventListener('DOMContentLoaded', () => {
  // 选择根元素（html 或 body，推荐 html）
  const rootElement = document.documentElement; // 对应 <html> 标签
  
  // 确保根元素高度充满屏幕
  rootElement.style.height = '100%';
  rootElement.style.overflow = 'auto'; // 允许滚动
  
  // 初始化 perfect-scrollbar
  new PerfectScrollbar(rootElement, {
    suppressScrollX: true, // 隐藏水平滚动条（可选）
    wheelPropagation: false // 避免滚动事件冒泡（可选）
  });
})


import AV from 'leancloud-storage'
AV.init({
  appId: '9rXqIZHsGPUfozzLKmCRzDaU-gzGzoHsz',
  appKey: 'W4rV92VWVQq2GRbXEjf93tSb',
  serverURL: 'https://9rxqizhs.lc-cn-n1-shared.com'
})
Vue.prototype.$AV = AV
Vue.config.productionTip = false
import 'animate.css'
import WOW from 'wowjs'
Vue.prototype.$wow = new WOW.WOW({
  boxClass: 'wow', // 触发动画的元素类名（默认即可）
  animateClass: 'animated', // 动画类名（与 animate.css 对应）
  offset: 0, // 元素距离可视区域多少像素时触发动画
  mobile: true, // 是否在移动设备上执行动画
  live: true // 是否监听动态添加的元素
})


// 显式挂载到 window，确保全局可访问
window.WOW = WOW;

// 导入 Vue Router
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
// 引入 Element UI 默认样式（必须保留，否则图标和基础样式丢失）
import 'element-ui/lib/theme-chalk/index.css'
// 引入自定义主题（放在默认样式之后，确保覆盖）
// import './styles/element-theme.css'
import './styles/element-cover.css' // 引入直接覆盖的样式

Vue.use(ElementUI)
// 路由配置文件（需要自己创建）
import router from './router'
// 使用路由和 Element UI
Vue.use(VueRouter)

// 创建全局事件总线
Vue.prototype.$bus = new Vue()


// 路由后置守卫
router.afterEach((to) => {
  if (to.path === '/login') {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
})


// 核心配置项
const config = {
  // 基础断点（可根据需求调整）
  breakpoint: 768,
  // 缓冲区间：避免折叠屏等中间尺寸频繁触发（±20px）
  buffer: 20,
  // 防抖延迟：500ms，确保尺寸稳定后再判断
  debounceDelay: 500,
  // 目标网址
  pcUrl: 'https://www.3pg.cn',
  mobileUrl: 'https://m.3pg.cn'
}

/**
 * 防抖函数：避免频繁触发
 * @param {Function} func 执行函数
 * @param {Number} delay 延迟时间
 * @returns {Function} 防抖后的函数
 */
function debounce(func, delay) {
  let timer = null
  return function(...args) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

/**
 * 判断并执行跳转逻辑
 */
function handleScreenRedirect() {
  const screenWidth = window.innerWidth
  const currentUrl = window.location.href
  
  // 1. 计算有效阈值（加入缓冲）
  const lowerThreshold = config.breakpoint - config.buffer
  const upperThreshold = config.breakpoint + config.buffer

  // 2. 判断当前应该跳转的目标
  let targetUrl = ''
  if (screenWidth <= lowerThreshold) {
    // 小屏：移动端
    targetUrl = config.mobileUrl
  } else if (screenWidth >= upperThreshold) {
    // 大屏：PC端
    targetUrl = config.pcUrl
  } else {
    // 中间尺寸（折叠屏）：不跳转，保持当前页面
    return
  }

  // 3. 避免重复跳转（当前已在目标网址则不处理）
  if (currentUrl.includes(targetUrl) || currentUrl === targetUrl) {
    return
  }

  // 4. 执行跳转
  window.location.href = targetUrl
}

// 页面加载时立即执行一次判断
handleScreenRedirect()

// 监听窗口尺寸变化，加入防抖避免频繁触发
window.addEventListener('resize', debounce(handleScreenRedirect, config.debounceDelay))



new Vue({
  router,  // 注入路由
  store,
  i18n, // 注入国际化实例
  render: h => h(App),
}).$mount('#app')
